/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PerfEnergyKpiType } from '../../models/perf-energy-kpi-type';
import { PerfEnergyTimeSeriesStationPagedList } from '../../models/perf-energy-time-series-station-paged-list';

export interface GetPerfEnergyTimeSeriesStation$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The type of KPI, we want to GET
 */
  kpiType: PerfEnergyKpiType;
  
    /**
     * Body for search kpi
     */
    body?: any
}

export function getPerfEnergyTimeSeriesStation$Any(http: HttpClient, rootUrl: string, params: GetPerfEnergyTimeSeriesStation$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyTimeSeriesStationPagedList>> {
  const rb = new RequestBuilder(rootUrl, getPerfEnergyTimeSeriesStation$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.path('kpiType', params.kpiType, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PerfEnergyTimeSeriesStationPagedList>;
    })
  );
}

getPerfEnergyTimeSeriesStation$Any.PATH = '/custom/time-series/perf-energy/{kpiType}/group-by-station';
